import { render, staticRenderFns } from "./GrantsConstraintsPlansSlidDetailsBtns.vue?vue&type=template&id=c582445e&"
import script from "./GrantsConstraintsPlansSlidDetailsBtns.vue?vue&type=script&lang=js&"
export * from "./GrantsConstraintsPlansSlidDetailsBtns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports